import { QueryKey } from '@tanstack/react-query'

export interface ResourceInvalidationConfig {
  listRoots: (slug: string) => QueryKey[]
  detail?: (slug: string, resourceId: number) => QueryKey
  extraInvalidationKeys?: (slug: string, resourceId: number) => QueryKey[]
}

export const RESOURCE_INVALIDATION_CONFIG: Record<string, ResourceInvalidationConfig> = {
  document: {
    listRoots: slug => [
      [slug, 'documents'],
      [slug, 'interactive-report'],
      [slug, 'report-entries']
    ],
    detail: (slug, resourceId) => [slug, 'documents', resourceId],
    extraInvalidationKeys: (slug, resourceId) => [
      [slug, 'documents', resourceId, 'entries'],
      [slug, 'document_audit_trail', resourceId]
    ]
  },
  account: {
    listRoots: slug => [
      [slug, 'accounts'],
      [slug, 'tabular_accounts'],
      [slug, 'auto_complete_accounts']
    ],
    detail: (slug, resourceId) => [slug, 'accounts', resourceId]
  },
  file: {
    listRoots: slug => [[slug, 'files']],
    detail: (slug, resourceId) => [slug, 'files', resourceId]
  },
  folder: {
    listRoots: slug => [[slug, 'folders']],
    detail: (slug, resourceId) => [slug, 'folders', resourceId]
  },
  invoice: {
    listRoots: slug => [
      [slug, 'invoices'],
      [slug, 'combined_invoices']
    ],
    detail: (slug, resourceId) => [slug, 'invoices', resourceId]
  },
  contact: {
    listRoots: slug => [[slug, 'contacts']],
    detail: (slug, resourceId) => [slug, 'contacts', resourceId]
  },
  tag: {
    listRoots: slug => [[slug, 'tags']],
    detail: (slug, resourceId) => [slug, 'tags', resourceId]
  },
  product: {
    listRoots: slug => [[slug, 'products']],
    detail: (slug, resourceId) => [slug, 'products', resourceId]
  },
  period: {
    listRoots: slug => [[slug, 'periods']],
    detail: (slug, resourceId) => [slug, 'periods', resourceId]
  },
  vat_period: {
    listRoots: slug => [[slug, 'vat_periods']],
    detail: (slug, resourceId) => [slug, 'vat_periods', resourceId]
  },
  accounting_rule: {
    listRoots: slug => [[slug, 'automationRules']]
  },
  comment: {
    listRoots: slug => [[slug, 'document_audit_trail']]
  },
  usership: {
    listRoots: slug => [
      [slug, 'people'],
      [slug, 'invitations']
    ],
    detail: (slug, resourceId) => [slug, 'people', resourceId]
  }
}
